import { I18n } from '@affine/i18n';
import { TranslationExtension } from '@blocksuite/affine-shared/services';
import { signal } from '@preact/signals-core';

const language$ = signal(I18n.language);

I18n.on('languageChanged', language => {
  language$.value = language;
});

export const affineTranslationExtension = TranslationExtension({
  language$,
  translate: source => I18n.t(source),
});
